import React, { useState, useEffect } from 'react';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../../uiComponents/MuiTable/StyledTable.js'
import MuiTableHeader from '../../../../uiComponents/MuiTable/MuiTableHeader';
import muiCheckboxStyles from '../../../../uiComponents/MuiInput/MuiCheckboxStyles';
import LiteratureLink from '../../../../uiComponents/LiteratureLink.js';
import ReviewStatus from '../../../../config/ReviewStatus.js'
import Modal from 'react-modal';
import {  Edit } from "@mui/icons-material";

import {
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Button,

  TableBody,
  TableContainer,
  Typography,
  Box,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';


const useStyles = makeStyles({
  root: {
    background: '#006778',
    color: 'white',
    fontFamily: "Open Sans",
  },
  litButtons: {
    margin: '.1rem .5rem .1rem 0',
    padding: '6px 10px',
    color: 'white'
  },
});


export default function ConsensusLiteratureTable(props) {
    const classes = useStyles();
  const [tableData, setTableData] = useState(props.data);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const checkboxClasses = muiCheckboxStyles();
  //intialize tableData
  useEffect(() => {
    setTableData(props.data);
  }, [props.data]);

  // Use useMemo to recalculate sortedTableData when tableData changes
  const sortedTableData = React.useMemo(() => {
    return tableData.sort((a, b) => {
      return a.reviewer.localeCompare(b.reviewer);
    });
  }, [tableData]);

  //Important: The id here must match the column name in the returned data. Label can be different for display.
  const headCells = [
    { label: 'Reviewer', id: 'reviewer', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'PMID', id: 'pmid', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'Literature Category', id: 'litCategory', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'Evaluation', id: 'litEval', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'Comments', id: 'litComment', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'Final Review', id: 'actionRow', type: 'noSort', numeric: false, disablePadding: false, disableSort: true },
    { label: '', id: 'actionRowSpacer', type: 'noSort', numeric: false, disablePadding: false, disableSort: true },

  ];
  function onClick(row) {
    // console.log('Edit Final Review clicked for row:', row);
    setSelectedRow(row);
    setModalIsOpen(true);
  }
  
  function closeModal() {
    setModalIsOpen(false);
    setSelectedRow(null);
  }

  const saveFinalReview = () => {
    if (selectedRow) {
      // Update the tableData with the selected row changes
      const updatedTableData = tableData.map((row) => {
        if (row.litReviewId === selectedRow.litReviewId) {
          return selectedRow;
        }
        return row;
      });
      
      // Call parent's handler with the updated data
      props.handleFinalLitEvalChange(updatedTableData);
      
      // Close the modal
      closeModal();
    }
  };

  const renderFinalLiteratureCheckbox = (row) => {  
    return (
        <div className="muiFormItem">
                {props.literatureCategory && (
                  <FormControl 
                    fullWidth                    
                  >
                    <FormLabel
                      component="legend"
                      className={checkboxClasses.formLabel}
                      style={{ color: 'var(--alt-black)' }}
                      required
                    >
                      Evaluation Criteria
                    </FormLabel>
                    {renderCheckboxItems(row)} 
                  </FormControl>
                )}
              </div>
             
    )
     
  }
  const renderCheckboxItems = (row) => {
    // Use selectedRow if in modal, otherwise use the passed row
    const targetRow = modalIsOpen && selectedRow ? selectedRow : row;
    
    return props.literatureCategory
      .filter((category) => category.literatureCategoryLabel === targetRow.litCategory)
      .map((filterCategory) =>
        filterCategory.acmgCriterias.map((criteria) => {
          const disabled = targetRow.finalAcmgEvidCriteriaId && targetRow.finalAcmgEvidCriteriaId.length > 0 ? criteria.charAt(0) !== targetRow.finalAcmgEvidCriteriaId[0].charAt(0) : false;
          const checked = targetRow.finalAcmgEvidCriteriaId?.includes(criteria);
          return (
            <FormControlLabel
              key={criteria}
              classes={{ label: checkboxClasses.checkboxLabel }}
              control={
                <Checkbox
                  name={criteria}
                  classes={{
                    root: checked ? checkboxClasses.checkboxSelected : checkboxClasses.checkboxRoot,
                  }}
                  disabled={disabled}
                  value={criteria}
                  checked={checked}
                  onChange={() => {
                    onEvaluationCheckboxChange(criteria, targetRow);
                  }}
                />
              }
              label={criteria}
            />
          );
        })
      );
  };
  const onEvaluationCheckboxChange = (criteria, row) => {
    // Update the selected row with the new criteria
    const currentEvals = selectedRow.finalAcmgEvidCriteriaId 
      ? selectedRow.finalAcmgEvidCriteriaId.split(',').map(s => s.trim()) 
      : [];
    
    // Toggle criteria in the array - add if not present, remove if present
    const updatedEvals = currentEvals.includes(criteria)
      ? currentEvals.filter(e => e !== criteria)
      : [...currentEvals, criteria];
    // Update the selected row with the new final criteria
    setSelectedRow({
      ...selectedRow,
      finalAcmgEvidCriteriaId: updatedEvals.join(', ')
    });
  }
  return (
    <section>
      <h2 className="sectionHeading">Summary of Variant Interpretation Literature</h2>
      <div className="sectionContent">
        {sortedTableData.length > 0 ? (
          <StyledPaper>
            <TableContainer>
              <StyledTable
                size='small'
                aria-label="consensus literature table">
                <MuiTableHeader
                  headCells={headCells}
                />
                <TableBody>
                  {sortedTableData
                    .map((row, index) => {
                        // Format litEval to add a space after each comma
                        const formattedLitEval = row.litEval
                        ? row.litEval.split(',').map(s => s.trim()).join(', ')
                        : '';

                        // Final Review reflects the (possibly edited) final consensus
                        // value, not the individual reviewer's original evaluation.
                        const formattedFinalLitEval = row.finalAcmgEvidCriteriaId
                        ? row.finalAcmgEvidCriteriaId.split(',').map(s => s.trim()).join(', ')
                        : '';

                        return (
                        <StyledTableRow tabIndex={-1} key={index}>
                          <StyledTableCell style={{ minWidth: '120px' }}>{row.reviewer}</StyledTableCell>
                          <StyledTableCell style={{ minWidth: '120px' }}><LiteratureLink pmid={row.pmid} /></StyledTableCell>
                          <StyledTableCell>{row.litCategory}</StyledTableCell>
                          <StyledTableCell>{formattedLitEval}</StyledTableCell>
                          <StyledTableCell>{row.litComment}</StyledTableCell>
                          {/* <StyledTableCell>{renderFinalLiteratureCheckbox(row)}</StyledTableCell> */}
                          <StyledTableCell>{formattedFinalLitEval}</StyledTableCell>  
                          
                            <StyledTableCell style={{width: '20%'}}>
                              {props.reviewStatus !== ReviewStatus.CLOSED ? (
                              <Button
                                      className={classes.litButtons}
                                      color='primary'
                                      variant="contained"
                                      id={`${row.litReviewId}-edit`}
                                    onClick={() => onClick(row)}
                                  >
                                    <Edit className="litIcons" alt="edit" fontSize='small' />
                                    Edit
                                  </Button>):''}
                                  </StyledTableCell>
                        </StyledTableRow>
                        
                        );
                    })}
                </TableBody>
              </StyledTable>
            </TableContainer>
          </StyledPaper>
        ) : (
          <div className="noData">
            No literature to display for this consensus
          </div>
        )
        }
      </div>

      {/* Final Review Edit Modal */}
      <Modal
        className="modal"
        overlayClassName="modalOverlay"
        aria-modal="true"
        contentLabel="Edit Final Review"
        shouldCloseOnOverlayClick={true}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
      >
        <div className="modalHeader">Final Literature Review</div>
        <div className="modalContent">
          {selectedRow && (
            <Box>
              <Typography variant="subtitle1">
                <strong>Reviewer:</strong> {selectedRow.reviewer}
              </Typography>
              <Typography variant="subtitle1">
                <strong>PMID:</strong> <LiteratureLink pmid={selectedRow.pmid} />
              </Typography>
              <Typography variant="subtitle1">
                <strong>Literature Category:</strong> {selectedRow.litCategory}
              </Typography>
              <Typography variant="subtitle1">
                <strong>Evaluation:</strong> {selectedRow.litEval}
              </Typography>
              <Typography variant="subtitle1">
                <strong>Comments:</strong> {selectedRow.litComment}
              </Typography>
              
              <Box mt={3}>
                {renderFinalLiteratureCheckbox(selectedRow)}
              </Box>
            </Box>
          )}
        </div>
        <div className="modalButtons">
          <button className="modalButton" onClick={closeModal}>
            Cancel
          </button>
          <button className="modalButton primaryButton" onClick={saveFinalReview}>
            Continue & Close
          </button>
        </div>
      </Modal>

    </section>
  );
}